(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blog-post-content-with-toc"] && !Shopify.designMode) return;
  try {
    class BlogPostTableOfContents extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready !== undefined) return;

      const headings = this.querySelectorAll('.blog-post-content h2');
      const tocLinks = this.querySelectorAll('.article-toc__list > li:not(.article-toc__cta) > a');

      headings.forEach((heading, index) => {
        const target = tocLinks[index]?.getAttribute('href');

        if (target?.startsWith('#')) heading.id = target.slice(1);
      });

      this.#addCopyButtons();
      this.dataset.ready = '';
    }

    /** Adds a copy button to each article code block. Collapsible blocks copy the full code, not the preview. */
    #addCopyButtons() {
      const label = this.dataset.copyLabel || 'Copy code';

      for (const codeBlock of this.querySelectorAll('.blog-post-content .cw-blog-code')) {
        const code = codeBlock.querySelector(':scope > details > pre, :scope > pre:not(.cw-blog-code-preview)');

        if (!code) continue;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cw-blog-code__copy';
        button.setAttribute('aria-label', label);
        button.title = label;
        button.innerHTML = `
          <svg class="cw-blog-code__copy-icon cw-blog-code__copy-icon--copy" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">
            <rect x="5.5" y="5.5" width="8" height="8" rx="1.5"/>
            <path d="M10.5 3.5v-.25A1.25 1.25 0 0 0 9.25 2h-6A1.25 1.25 0 0 0 2 3.25v6a1.25 1.25 0 0 0 1.25 1.25h.25"/>
          </svg>
          <svg class="cw-blog-code__copy-icon cw-blog-code__copy-icon--done" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 8.5l3.25 3.25L13 4.75"/>
          </svg>`;
        button.addEventListener('click', () => this.#copy(button, code.textContent ?? ''));
        codeBlock.append(button);
      }
    }

    /**
     * @param {HTMLButtonElement} button
     * @param {string} text
     */
    async #copy(button, text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        return;
      }

      const status = this.querySelector('[data-copy-status]');
      if (status) status.textContent = this.dataset.copiedLabel || 'Code copied';

      button.dataset.copied = '';
      clearTimeout(this.#resetTimer);
      this.#resetTimer = setTimeout(() => {
        delete button.dataset.copied;
        if (status) status.textContent = '';
      }, 2000);
    }

    /** @type {number | undefined} */
    #resetTimer;

    disconnectedCallback() {
      clearTimeout(this.#resetTimer);
    }
  }

  if (!customElements.get('blog-post-table-of-contents')) {
    customElements.define('blog-post-table-of-contents', BlogPostTableOfContents);
  }
  } catch(e) { console.error(e); }
})();

})();
